export default {
  submit_response: `/response`,
  getting_user_details: `/response/sellerdetails/`,
};

/* Legacy configuration - kept for reference
export default {
  submit_response: "/response",
  getting_user_details: "/response/sellerdetails/",
};
*/
